module.exports = __webpack_public_path__ + "static/media/Sara_home1.91d2d744.png";